// The staff assistant: a colleague asks the AI directly (e.g. support staff checking a technical answer before replying
// to a customer). Longer, precise answers with codes and their sources, using the company's knowledge, files and skills.
// Nothing is sent to a customer; every answer is in the AI log (source "assist").
import { callFn } from "../sb.ts";
import { t } from "../i18n.ts";
import { h, mount, toast } from "../ui.ts";
import { usedText } from "./ai.ts";

export function assistant(root: HTMLElement) {
  const turns: { from: "customer" | "us"; text: string; note?: string }[] = [];
  const msgs = h("div", { class: "msgs try" });
  const input = h("textarea", { rows: 3, dir: "auto", placeholder: t("Ask a question, e.g. the code for a service / ما هو رمز الخدمة؟") });
  const go = h("button", { class: "primary" }, t("Ask"));
  const render = () => {
    mount(msgs, turns.map((x) => h("div", { class: "msg " + (x.from === "customer" ? "out" : "in ai") },
      h("p", { dir: "auto", class: "pre" }, x.text), x.from === "us" && h("button", { class: "link", onclick: () => copy(x.text) }, t("Copy")),
      x.note && h("small", { class: "muted" }, x.note))));
    msgs.scrollTop = msgs.scrollHeight;
  };
  const ask = async () => {
    if (!input.value.trim() || go.disabled) return;
    turns.push({ from: "customer", text: input.value.trim() });
    input.value = "";
    render();
    go.disabled = true; go.textContent = t("Thinking… (up to a minute)");
    const r = await callFn("ai-agent", { mode: "assist", turns: turns.map(({ from, text }) => ({ from, text })) });
    go.disabled = false; go.textContent = t("Ask");
    if (!r.ok) { turns.pop(); render(); return toast(r.error ?? "error", true); }
    turns.push({ from: "us", text: r.reply || "—", note: usedText(r.used, r.tokens) });
    render();
  };
  go.addEventListener("click", ask);
  input.addEventListener("keydown", (e: KeyboardEvent) => { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) ask(); });
  mount(root, h("main", { class: "card" }, h("h2", {}, t("Assistant")),
    h("p", { class: "muted" }, t("Ask the AI as a colleague: it answers from the AI knowledge, files and skills, with codes and where they come from. Nothing is sent to customers.")),
    h("div", { class: "try-box" }, msgs, h("div", { class: "row" }, input, go),
      h("button", { class: "link", onclick: () => { turns.length = 0; render(); } }, t("New question")))));
}
async function copy(s: string) {
  try { await navigator.clipboard.writeText(s); toast(t("Copied")); } catch { toast("copy failed", true); }
}
